import React from 'react';
import { TrashIcon } from 'lucide-react';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { notificationService } from 'features/crm/api';

const NotificationItem = ({ item, refreshList }) => {
  const { closeModal } = useLayout();
  const { showToast } = useStateContext();
  const { meta, title, description, tag, client, employee, is_read } = item;
  const receiver = client || employee;
  // Generate the tag color dynamically using the RGB values from the model
  const tagColor = `rgb(${tag.red}, ${tag.green}, ${tag.blue})`;

  const handleDeleteNotification = async () => {
    const confirmDelete = window.confirm(`Вы уверены, что хотите удалить уведомление "${title}"?`);
    if (confirmDelete) {
      const response = await notificationService.delete(meta.id);
      if(response.status === 0) {
        showToast({
          title: 'Успешно!',
          content: `Уведомление "${title}" удалено`,
          type: 'success',
        });
        closeModal();
        refreshList ? refreshList() : null;
      }
      else{
        showToast({
          title: 'Ошибка!',
          content: response.message || 'Что-то пошло не так!',
          type: 'error',
        });
      }
    }
  };

  return (
    <div className={`p-4 border-b ${is_read ? 'bg-gray-50' : 'bg-white'} hover:bg-gray-100 transition-colors`}>
      {/* Header */}
      <div className='flex items-center justify-between mb-2'>
        <div className='flex items-center space-x-2'>
          {/* Tag */}
          <span
            className='text-xs font-medium px-2 py-1 rounded-full'
            style={{ backgroundColor: tagColor, color: 'white' }}
          >
            {tag.text}
          </span>
          {/* Notification Title */}
          <h3 className='text-lg font-semibold'>{title}</h3>
        </div>
        <div className='flex items-center space-x-2'>
          {/* Read/Unread Indicator */}
          {!is_read && (
            <span className='w-2 h-2 bg-blue-500 rounded-full'></span>
          )}
          {/* Delete Button */}
          <button 
            className='text-white px-2 py-1 rounded-md bg-red-500 hover:bg-red-600' 
            onClick={(e) => { e.stopPropagation(); handleDeleteNotification(); }}
          >
            <TrashIcon size={14} />
          </button>
        </div>
      </div>

      {/* Description */}
      <p className='text-sm text-gray-600 mb-2'>{description}</p>

      {/* Client Information */}
      <div className='text-sm text-gray-500'>
        <span className='font-medium'>Получатель:</span> {receiver?.meta.name}
      </div>

      {/* Meta Information */}
      <div className='text-xs text-gray-400 mt-2'>
        <span>ID: {meta.id}</span> · <span>Тип: {meta.type}</span>
      </div>
    </div>
  );
};

export default NotificationItem;